// @ts-nocheck
import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import Grid from '@mui/material/Grid';
import LetterAvatar from "../Componentes/LetterAvatar";
import KeyCloak from "../Auth/Keycloak";
import { useAuth } from "../Auth/State/AuthContext";
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import Tooltip from '@mui/material/Tooltip';

// Define styled components
const RootStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    padding: '4px 8px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    "&:hover": {
        backgroundColor: 'rgba(183, 18, 52, 0.06)',
    },
}));

const NameStyled = styled(Typography)(({ theme }) => ({
    fontWeight: '700',
    fontSize: "1.2rem",
    lineHeight: '1.3',
    textAlign: 'center',
    color: '#2d2d2d',
    wordBreak: 'break-word',
}));

const UsernameStyled = styled(Typography)(({ theme }) => ({
    fontSize: "0.9rem",
    color: "#888",
    textAlign: 'center',
    marginTop: '2px',
}));

const InfoStyled = styled(Grid, {
    shouldForwardProp: (prop) => prop !== 'visibilityMenu'
})(({ theme, visibilityMenu }) => ({
    transition: 'all .3s ease-in-out',
    transformOrigin: 'top',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    paddingBottom: "12px",
    paddingTop: "6px",
    opacity: visibilityMenu ? 1 : 0,
    transform: visibilityMenu ? "scaleY(1)" : "scaleY(0)",
    maxHeight: visibilityMenu ? "1000px" : "0px",
    overflow: 'hidden',
}));

export default function PersonalInfo(props) {
    const { className, visibilityMenu, triggerChangeVisibilityMenu } = props;
    const { user, isLogedIn, impersonado } = useAuth();
    const [userInfo, setUserInfo] = React.useState({
        username: '',
        name: ''
    });

    React.useEffect(() => {
        if (KeyCloak.isLoggedIn() && isLogedIn()) {
            setUserInfo(prevState => ({
                ...prevState,
                username: user.uid,
                name: user.name
            }));
        }
    }, [user, isLogedIn]);

    return (
        <RootStyled className={clsx(className)} onClick={triggerChangeVisibilityMenu}>
            {impersonado ? (
                <div>
                    <br />
                    <Tooltip title={"Usuario impersonado"}>
                        <SupervisorAccountIcon />
                    </Tooltip>
                </div>
            ) : null}
            <LetterAvatar
                letter={userInfo.username.charAt(0).toUpperCase()}
                alt={userInfo.name}
                toggleOpen={triggerChangeVisibilityMenu}
                visibilityMenu={visibilityMenu}
            />
            <InfoStyled item xs={12} zeroMinWidth visibilityMenu={visibilityMenu}>
                <NameStyled>
                    {userInfo.name}
                </NameStyled>
                <UsernameStyled>
                    {userInfo.username}
                </UsernameStyled>
            </InfoStyled>
        </RootStyled>
    );
}
